import React from "react";
import { Tab, Row, Col, ListGroup } from "react-bootstrap";
import AddFactory from "../Registration/Factory/addFactory";
import DelFactory from "../Registration/Factory/delFactory";
import AltFactory from "../Registration/Factory/altFactory";
import ReportFactories from "../Reports/reportFactories";
import BottomBar from "../../Components/bottomBar/bottomBar";
import "./prelude.css";
import Api from "../../services/api";
import TableList from "../../Components/tableList/TableList";
import Alert from "../../Components/alert/Alert";
import MessageTable from "../../Components/messageTable/MessageTable";
import TopBar from "../../Components/topBar/topBar";
import { handleColor } from "../../services/Functions";

const prelude_factory = () => {
  return (
    <>
      <header>
        <TopBar></TopBar>{" "}
      </header>
      <div className="prelude_container">
        <Sidebar></Sidebar>
      </div>
      <BottomBar></BottomBar>
    </>
  );
};

class Sidebar extends React.Component {
  state = {
    data: [],
    keys: [],
    render: false,
    message: "",
    click: false,
    controller: "",
    id: "",
  };

  async componentDidMount() {
    let array = [];
    await Api.get("/factorys")
      .then((response) => {
        response.data.forEach((element) => {
          array.push({
            Planta: element.description,
            Código: element.code,
          });
        });
        if (array.length > 0) this.setState({ data: array, render: true });
      })
      .catch((err) => {
        this.setState({ message: "" });
      });
  }

  handleClick = () => {
    if (this.props.click === false) {
      this.setState({ click: true });
      return true;
    } else {
      this.setState({ click: false });
      return false;
    }
  };

  render() {
    const { show, message } = this.state;

    return (
      <Tab.Container defaultActiveKey="list">
        <Row style={{ width: "100%", height: "100%" }}>
          <div className="sidebar1 ">
            <div className="sidebar2">
              <Col className="sidebarColumn" mountOnEnter unmountOnExit>
                <ListGroup>
                  <ListGroup.Item
                    id="lg1"
                    onClick={handleColor}
                    className="listGroup"
                    eventKey="list"
                  >
                    Plantas
                  </ListGroup.Item>
                  <ListGroup.Item
                    id="lg2"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="add"
                  >
                    Adicionar Planta
                  </ListGroup.Item>
                  <ListGroup.Item
                    id="lg3"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="alt"
                  >
                    Alterar Planta
                  </ListGroup.Item>
                  <ListGroup.Item
                    id="lg4"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="del"
                  >
                    Deletar Planta
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </div>
            <Col
              className="col3"
              style={{
                top: "5%",
                marginLeft: "1.5%",
                width: "100%",
                height: "78vh",
                overflow: "hidden",
              }}
            >
              {show ? (
                <Alert
                  show={show}
                  message={message}
                  parentCallback={this.callbackfunction}
                />
              ) : null}
              <Tab.Content>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="list">
                  {this.handleClick ? <ReportFactories /> : null}
                </Tab.Pane>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="add">
                  {this.handleClick ? <AddFactory /> : null}
                </Tab.Pane>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="alt">
                  {this.handleClick ? <AltFactory /> : null}
                </Tab.Pane>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="del">
                  {this.handleClick ? <DelFactory /> : null}
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}

export default prelude_factory;
